import React, { useState } from 'react'
import SimpleModal from 'components/SimpleModal'
import { CustomButton, SimpleTitleCard } from 'styles/global'
import { ModalContent } from '../style'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { KANBAN } from 'store/modules/kanban/types'
import { maskCPF } from 'util/masks'
import { Label } from 'reactstrap'
import useRedux from 'hooks/useRedux'
import * as kanbanActions from 'store/modules/kanban/actions'
import InputCustom from 'components/Inputs'
import { validaCpf } from 'util/validations'
import { GoPersonAdd } from 'react-icons/go'

const ModalCpf = () => {
  const { modalCpf } = useSelector<ApplicationState, KANBAN>(
    (state) => state.kanban
  )

  const { dispatch } = useRedux()

  const [invalid, setInvalid] = useState(false)

  const onChange = (value: string) => {
    dispatch(kanbanActions.setCpfModalCpf(value))
  }

  const adicionarCliente = () => {
    if (!validaCpf(modalCpf.cpf.trim())) {
      setInvalid(true)
      return
    } else {
      setInvalid(false)
      dispatch(kanbanActions.adicionarClienteKanbanSaga(modalCpf.cpf))
    }
  }

  const onClose = () => {
    dispatch(kanbanActions.setCpfModalCpf(''))
    dispatch(kanbanActions.setIsOpenModalCpf(false))
    setInvalid(false)
  }

  return (
    <SimpleModal
      dataBackdrop="static"
      isOpen={modalCpf.isOpen}
      toggle={onClose}
      size="md"
      header={
        <SimpleTitleCard>
          <GoPersonAdd className="icon" />
          Adicionar cliente ao kanban
        </SimpleTitleCard>
      }
      footer={
        <div className="d-flex gap-3">
          <CustomButton background="var(--roxo-riber)" onClick={onClose}>
            Cancelar
          </CustomButton>
          <CustomButton onClick={adicionarCliente}>Adicionar</CustomButton>
        </div>
      }
    >
      <ModalContent>
        <div className="d-flex flex-column">
          <Label className="label-12">CPF do cliente</Label>
          <InputCustom
            type="text"
            value={modalCpf.cpf}
            onChange={(e) => onChange(maskCPF(e.target.value))}
            placeholder="Digite o CPF do cliente"
            invalid={invalid}
            maxLength={14}
            onInput={(e: React.FormEvent<HTMLInputElement>) => {
              const input = e.currentTarget
              input.value = maskCPF(input.value)
            }}
          />
        </div>
      </ModalContent>
    </SimpleModal>
  )
}

export default ModalCpf
